import { LitElement, html, ref, createRef } from 'https://cdn.jsdelivr.net/gh/lit/dist@3/all/lit-all.min.js';


class LitElementEjected extends LitElement {
    createRenderRoot() {
        // Returning `this` will render the template directly into the light DOM
        return this;
    }
}

function formatDate(date) {
    return new Date(date).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
}

function formatError(error) {
    console.log('error', error)
    return error.message.split('["')[1].split('"]')[0];
}

const sms = {
    elements: {
        widget: '',
        addToDialog: '',
        productForm: document.querySelector('form.product-form[action="/cart/add"]'),
        variantInput: document.querySelector('input[name="id"]'),
        planInput: ''
    },
    hrefs: {
        base: document.getElementById("sms-base-styles").href
    },
    icons: {
        chevron: html`<svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="m5 9 7 7 7-7" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg>`,
        close: html`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" height="24" viewBox="0 0 24 24" width="24"><clipPath id="a"><path d="m4 4h16v16h-16z"/></clipPath><g clip-path="url(#a)" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2"><path d="m14.4229 9.57715-4.84575 4.84575"/><path d="m9.57715 9.57715 4.84575 4.84575"/><path d="m12 19.4286c4.1027 0 7.4286-3.3259 7.4286-7.4286 0-4.10267-3.3259-7.42856-7.4286-7.42856s-7.42859 3.32589-7.42859 7.42856c0 4.1027 3.32589 7.4286 7.42859 7.4286z"/></g></svg>`,
        truck: html`<svg fill="currentColor" width="18" height="18" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" style="vertical-align: middle;"><path d="M15.48 12c-.13.004-.255.058-.347.152l-2.638 2.63-1.625-1.62c-.455-.474-1.19.258-.715.712l1.983 1.978c.197.197.517.197.715 0l2.995-2.987c.33-.32.087-.865-.367-.865zM.5 16h3c.277 0 .5.223.5.5s-.223.5-.5.5h-3c-.277 0-.5-.223-.5-.5s.223-.5.5-.5zm0-4h3c.277 0 .5.223.5.5s-.223.5-.5.5h-3c-.277 0-.5-.223-.5-.5s.223-.5.5-.5zm0-4h3c.277 0 .5.223.5.5s-.223.5-.5.5h-3C.223 9 0 8.777 0 8.5S.223 8 .5 8zm24 11c-1.375 0-2.5 1.125-2.5 2.5s1.125 2.5 2.5 2.5 2.5-1.125 2.5-2.5-1.125-2.5-2.5-2.5zm0 1c.834 0 1.5.666 1.5 1.5s-.666 1.5-1.5 1.5-1.5-.666-1.5-1.5.666-1.5 1.5-1.5zm-13-1C10.125 19 9 20.125 9 21.5s1.125 2.5 2.5 2.5 2.5-1.125 2.5-2.5-1.125-2.5-2.5-2.5zm0 1c.834 0 1.5.666 1.5 1.5s-.666 1.5-1.5 1.5-1.5-.666-1.5-1.5.666-1.5 1.5-1.5zm-5-14C5.678 6 5 6.678 5 7.5v11c0 .822.678 1.5 1.5 1.5h2c.676.01.676-1.01 0-1h-2c-.286 0-.5-.214-.5-.5v-11c0-.286.214-.5.5-.5h13c.286 0 .5.214.5.5V19h-5.5c-.66 0-.648 1.01 0 1h7c.66 0 .654-1 0-1H21v-9h4.227L29 15.896V18.5c0 .286-.214.5-.5.5h-1c-.654 0-.654 1 0 1h1c.822 0 1.5-.678 1.5-1.5v-2.75c0-.095-.027-.19-.078-.27l-4-6.25c-.092-.143-.25-.23-.422-.23H21V7.5c0-.822-.678-1.5-1.5-1.5z"></path></svg>`
    },
}

class SMSWidget extends LitElementEjected {
    static get properties() {
        return {
            session: { type: Object },
            selectedVariant: { type: Object },
            selectedPlan: { type: Object },
            selectedPlanId: { type: Number },
            quantity: { type: Number },
            state: { type: String },
            selectedRadio: { type: String },
        };
    }

    constructor() {
        super();
        sms.elements.widget = this;
        this.state = 'loading';
        this.productId = this.dataset.productId;
        this.variantId = this.dataset.variantId;
        this.variants = [];
        this.quantity = 1;
        this.productPlans = [];
        this.variantPlans = [];
        this.selectedPlan = null;
        this.selectedPlanId = null;
        this.subOnly = false;
        this.dataSettings = JSON.parse(this.dataset.settings);
        this.addToEnabled = false;
        this.bindMethods();
    }

    connectedCallback() {
        super.connectedCallback();
        this.init();
    }

    async init() {
        this.session = await recharge.auth.loginShopifyAppProxy();
        await this.fetchData();
        this.setupVariantsAndPlans();
        this.setupInputs();
        this.state = 'idle';
    }

    async fetchData() {
        if (!this.session) return;
        
        if (this.session.customerId) {
            this.customer = await recharge.customer.getCustomer(this.session, {
                include: ['subscriptions']
            });
            this.subscriptions = this.customer.include.subscriptions.filter(sub => sub.status === 'active');
        }
        
        this.settings = await recharge.cdn.getCDNProductAndSettings(this.productId);
        this.storeSettings = this.settings.store_settings;
        this.widgetSettings = this.settings.widget_settings;
        this.productSettings = this.settings.product;
        this.productSettings.product_title = this.dataset.productTitle;
    }

    render() {
        if (this.state === 'loading') return;

        return html`
            ${this.renderContent()}
        `;
    }


     setupVariantsAndPlans() {
        // set variants and selected variant //
        this.variants = this.productSettings.variants.filter(v => v.is_published !== false);
        this.selectedVariant = this.variants.find(v => Number(v.id) === Number(this.variantId));
        let variantIndex;
        
        this.variants.forEach((variant, index) => {
            if (Number(variant.id) === Number(this.variantId)) {
                this.selectedVariant = variant;
                variantIndex = index;
            }
        });
        
        // Store the initial variant for one-time price display
        this.initialVariant = this.selectedVariant;

        // set product plans //
        this.productPlans = this.productSettings.selling_plan_groups.map(group => {
            const sellingPlan = group.selling_plans[0];
            const plan = {
                selling_plan_id: sellingPlan.selling_plan_id,
                selling_plan_group_id: group.selling_plan_group_id,
                selling_plan_name: sellingPlan.selling_plan_name,
                order_interval_frequency: sellingPlan.order_interval_frequency,
                order_interval_unit_type: sellingPlan.order_interval_unit_type,
                price_adjustments_value: sellingPlan.price_adjustments_value,
                price_adjustments_value_type: sellingPlan.price_adjustments_value_type,
            };
            
            return plan;
        });

        // set plans and selected plan //
        this.variantPlans = this.selectedVariant.selling_plan_allocations.sort((a, b) => a.sort_order - b.sort_order);
        this.selectedPlan = this.variantPlans[variantIndex] || null;
        this.discountPercentage = (this.selectedPlan) ? this.productPlans.find(p => Number(p.selling_plan_id) === Number(this.selectedPlan.selling_plan_id))?.price_adjustments_value : null;

        // set selected radio //
        this.subOnly = this.productSettings.is_subscription_only;
        this.selectedRadio = (this.subOnly) ? 'subscription' : this.dataSettings.widget_selection;
    }


    setupInputs() {
        // variant input //
        const variantInput = this.variantInput = sms.elements.variantInput;
        if (variantInput) {
            variantInput.addEventListener('change', this.updateVariant);
        }

        // plan input //
        const productForm = sms.elements.productForm;

        if (productForm) {
            this.planInput = document.createElement('input');
            this.planInput.type = 'hidden';
            this.planInput.name = 'selling_plan';
            this.planInput.value = (this.selectedPlan && this.selectedRadio === 'subscription') ? this.selectedPlan.selling_plan_id : ''; 
            productForm.appendChild(this.planInput);
            sms.elements.planInput = this.planInput;
        }

        // If one-time is selected by default, ensure first variant is selected
        if (this.selectedRadio === 'onetime' && this.variants.length > 0) {
            this.selectedVariant = this.variants[0];
            if (variantInput) {
                variantInput.value = this.selectedVariant.id;
            }
        }

        if (this.subscriptions && this.subscriptions.length > 0) {
            this.addToEnabled = true;
        }
    }

    bindMethods() {
        this.updateFrequency = this.updateFrequency.bind(this);
        this.updateVariant = this.updateVariant.bind(this);
        this.handleRadioChange = this.handleRadioChange.bind(this);
        this.handleVariantChange = this.handleVariantChange.bind(this);
    }

    renderContent() {
        const { selectedPlan, selectedVariant, selectedRadio, dataSettings } = this;
        const { subscription_title: subscriptionTitle, subscription_title_discount: subscriptionTitleDiscount, onetime_title: onetimeTitle, widget_order: widgetOrder } = dataSettings;
        const selected = { plan: selectedPlan, variant: selectedVariant, radio: selectedRadio };
        const subscriptionRadio = this.optionRadio('subscription', subscriptionTitle, selected, subscriptionTitleDiscount);
        const onetimeRadio = (!this.subOnly) ? this.optionRadio('onetime', onetimeTitle, selected) : '';
        const radios = widgetOrder === 'subscription' ? [subscriptionRadio, onetimeRadio] : [onetimeRadio, subscriptionRadio];

        return html`
            <div class="sms-widget__radios">
                <fieldset>
                    ${radios}
                </fieldset>
            </div>
        `;
    }

    optionRadio(type, label, selected, discountLabel) {
        const checked = (selected.radio === type);
        const isSubscription = (type === 'subscription');
        
        // Use initial variant for one-time price, current variant for subscription price
        const priceVariant = isSubscription ? selected.variant : this.initialVariant;
        const unitPrice = parseFloat(priceVariant.prices.unit_price).toFixed(2);

        const discountedPrice = (selected.plan) ? parseFloat(selected.plan.discounted_price).toFixed(2) : null;

        const isDiscounted = (discountedPrice < unitPrice);
        let price = (isSubscription && isDiscounted) ? discountedPrice : unitPrice;
        const title = (isSubscription && isDiscounted) ? discountLabel : label;

        if (!isSubscription) {
            price = this.variants[0].prices.unit_price
        }

        return html`
            <div class="sms-widget__radio ${(checked) ? 'sms-widget__radio--selected' : ''}">
                <label 
                    class="sms-widget__radio-label"
                    for="sms-frequency-${type}"
                >
                    <input
                        type="radio"
                        name="sms-frequency-type"
                        id="sms-frequency-${type}"
                        value="${type}"
                        ?checked=${checked}
                        @change=${this.handleRadioChange}
                    >
                    ${(!this.subOnly) ? html`<div class="sms-widget__radio-icon"></div>` : ''}
                    <div class="sms-widget__radio-label-block">
                        <div id="sms-widget-price-previous" style="display: none">Previously</div>
                        <div id="sms-widget-price-subscription" style="display: none">with subscription</div>

                        <span class="sms-widget__radio-text">${title}</span>
                        <span class="radio-price">
                            ${(isSubscription && isDiscounted) ? html`<span class="radio-price__previous" id="sms_widget_previous_price" aria-labelledby"sms-widget-price-previous sms_widget_previous_price">$${unitPrice}</span>` : ''}
                            <span class="radio-price__main" id="sms_widget_subscription_price" aria-labelledby="sms_widget_subscription_price sms-widget-price-subscription">$${price}</span>
                            ${(isSubscription && isDiscounted) ? html`<span class="radio-price__savings">-${this.discountPercentage}%</span>` : ''}
                        </span>
                    </div>
                </label>
                ${(type === 'subscription') ? html`
                    <div class="sms-widget__info">
                        ${this.renderVariantOptions()}
                        <span class="sms-widget__info-message">${sms.icons.truck}Free shipping. Pause or cancel anytime.</span>
                    </div>
                ` : ''}
            </div>
        `;
    }

    loadingTemplate() {
        return html`
            <div class="sms-widget__loading">
                <div class="sms-loader">
                    <div class="sms-loader__spinner"></div>
                </div>
            </div>
        `;
    }

    handleRadioChange(e) {
        const value = e.target.value;

        switch (value) {
            case 'onetime':
                this.selectedRadio = 'onetime';
                this.selectedVariant = this.variants[0];
                this.selectedPlan = this.selectedVariant.selling_plan_allocations[0];

                const plan = this.productPlans.find(p => Number(p.selling_plan_id) === Number((this.selectedVariant.selling_plan_allocations[0].selling_plan_id)));
                this.discountPercentage = plan ? plan.price_adjustments_value : null;

                if (this.planInput && this.selectedPlan) {
                    this.planInput.value = '';
                }
                
                if (this.variantInput) {
                    this.variantInput.value = this.selectedVariant.id;
                }
                break;
            case 'subscription':
                this.selectedRadio = 'subscription';
                if (this.planInput && this.selectedPlan) {
                    this.planInput.value = this.selectedPlan.selling_plan_id;
                }
                break;
        }
    
        this.requestUpdate();
    }
    
    renderFrequencyDescription() {
        if (!this.dataSettings.subscription_description) return;
        
        const product_plan = this.productPlans.find(p => Number(p.selling_plan_id) === Number(this.selectedPlan.selling_plan_id));
        const adjustment = `${product_plan.price_adjustments_value}%`;
        const description = this.dataSettings.subscription_description.replace('&lcub;discount&rcub;', adjustment).replace('{discount}', adjustment);

        return html`
            <p class="sms-widget__description" .innerHTML=${description}></p>
        `;
    }

    renderVariantOptions() {
        if (!this.variants || this.variants.length <= 1) return '';

        return html`
            <div class="sms-widget__variants">
                <label class="sms-widget__variants-label sr-only" for="sms-variant-select">
                    Select Variant
                </label>
                <fieldset class="sms-widget__variant-radios">
                    ${this.variants.map((variant, index) => this.variantRadio(variant, index))}
                </fieldset>
            </div>
        `;
    }

    variantRadio(variant, index) {
        const checked = this.selectedVariant && Number(this.selectedVariant.id) === Number(variant.id);
        const price = parseFloat(variant.prices.unit_price).toFixed(2);
        const title = variant.option_values[0].label || variant.name || 'Default';
        const plan = this.productPlans.find(p => Number(p.selling_plan_id) === Number((variant.selling_plan_allocations[index].selling_plan_id || variant.selling_plan_allocations[0].selling_plan_id)));
        const discountPercentage = plan ? plan.price_adjustments_value : null;

        return html`
            <label class="sms-widget__variant-radio ${checked ? 'sms-widget__variant-radio--selected' : ''}">
                <input
                    type="radio"
                    name="sms-variant"
                    id="sms-variant-${variant.id}"
                    value="${variant.id}"
                    ?checked=${checked}
                    @click=${this.handleVariantChange.bind(this, index, discountPercentage)}
                >
                <div class="sms-widget__variant-radio-content">
                    ${(discountPercentage != null) ? html`<span class="sms-widget__variant-save">Save ${discountPercentage}%</span>` : ''}
                    <span class="sms-widget__variant-title">${title}</span>
                    <span class="sms-widget__variant-subtitle">Every ${title.replace('Supply', '')}</span>
                </div>
            </label>
        `;
    }

    handleVariantChange(index, discountPercentage, e) {
        const variantId = e.target.value;
        this.selectedVariant = this.variants.find(v => Number(v.id) === Number(variantId));
        this.selectedPlan = (this.selectedVariant.selling_plan_allocations[index] || this.selectedVariant.selling_plan_allocations[0].selling_plan_id);
        this.selectedPlanId = this.selectedPlan.selling_plan_id;
        this.selectedRadio = 'subscription';
        this.discountPercentage = discountPercentage;
        
        if (this.variantInput) {
            this.variantInput.value = variantId;
            this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (this.planInput && this.selectedPlan) {
            this.planInput.value = this.selectedPlanId;
        }

        const subscriptionRadio = this.querySelector('input[name="sms-frequency-type"][value="subscription"]');
        const onetimeRadio = this.querySelector('input[name="sms-frequency-type"][value="onetime"]');
        if (subscriptionRadio) subscriptionRadio.checked = true;
        if (onetimeRadio) onetimeRadio.checked = false;

        this.updateURL(variantId);
        this.variantPlans = this.selectedVariant.selling_plan_allocations.sort((a, b) => a.sort_order - b.sort_order);
        
        this.requestUpdate();
    }

    updateURL(variantId) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url);
    }

    updateFrequency(e) {
        this.selectedPlan = this.variantPlans.find(p => Number(p.selling_plan_id) === Number(e.target.value));
        this.planInput.value = this.selectedPlan.selling_plan_id;
    }

    updateVariant(e) {
        const variantId = Number(e.target.value);
        let index;

        const variantIndex = this.variants.findIndex(v => Number(v.id) === variantId);
        this.variants.forEach((v, i) => {
            if (Number(v.id) === variantId) {
                this.selectedVariant = v;
                index = i;
            }
        })
        this.selectedPlan = this.selectedVariant.selling_plan_allocations[variantIndex] || this.selectedVariant.selling_plan_allocations[0];
    }
}

customElements.define('sms-widget', SMSWidget);

class SMSFrequencyRadios extends LitElementEjected {
    static properties = {
        label: { type: String },
        label_type: { type: String },
        plans: { type: Array },
        selectedPlan: { type: Object },
    }

    constructor() {
        super();
    }

    render() {

        return html`
            <fieldset>
                <legend class="sms-widget__dropdown-label" for="sms-frequency">${this.label}</legend>
                <div class="sms-widget__frequency-radios">
                    ${this.plans.map(plan => this.option(plan))}
                </div>
            </fieldset>
        `;
    }

    option(plan) {
        const use_interval = this.label_type === 'interval';
        const checked = this.selectedPlan && Number(this.selectedPlan.selling_plan_id) === Number(plan.selling_plan_id);
        let title = plan.selling_plan_name;
        
        if (use_interval) {
            title = `${plan.order_interval_frequency} ${plan.order_interval_unit_type}${plan.order_interval_frequency > 1 ? 's' : ''}`;
            if (plan.price_adjustments_value > 0) ``;
        }

        return html`
            <label class="sms-widget__frequency-radio ${(checked) ? 'sms-widget__frequency-radio--selected' : ''}" for="sms-frequency-${plan.selling_plan_id}">
                <input
                    type="radio"
                    name="sms-frequency"
                    id="sms-frequency-${plan.selling_plan_id}"
                    value="${plan.selling_plan_id}"
                    ?checked=${checked}
                    @change=${this.handleChange.bind(this, plan)}
                >
                <span>${title}</span>
                ${(use_interval) ? html`<span>Save ${plan.price_adjustments_value}%</span>` : ''}
            </label>
        `;
    }

    handleChange(plan, e) {
        this.selectedPlan = plan;
        sms.elements.widget.updateFrequency(e);
    }
}
customElements.define('sms-frequency-radios', SMSFrequencyRadios);
class SMSDialog extends LitElement {
    constructor() {
        super();
        this.dialogRef = createRef();
        this.close = this.close.bind(this);
    }

    firstUpdated() {
        super.firstUpdated();
        const base = document.createElement('link');
        base.rel = 'stylesheet';
        base.href = sms.hrefs.base;
        this.shadowRoot.appendChild(base);
    }
    
    render() {
        return html`
            <dialog class="sms-dialog" ${ref(this.dialogRef)}>
                <div class="sms-dialog__inner">
                    <button class="sms-dialog__close" @click=${this.close}>
                        <span class="sr-only">Close</span>
                    </button>
                    <slot name="title"></slot>
                    <slot name="content"></slot>
                </div>
            </dialog>
        `;
    }

    showModal() {
        this.dialogRef.value?.showModal();
        document.body.classList.add('scroll-locked');
        
    }

    close() {
        this.dialogRef.value?.close();
        document.body.classList.remove('scroll-locked');
    }
}
customElements.define('sms-dialog', SMSDialog);